import { useStateMachine } from "little-state-machine";
import Lottie from "lottie-react-web";

import LoaderBlack from "assets/animations/loader-black.json";
import LoaderWhite from "assets/animations/loader-white.json";

import { useBackgroundStyles } from "pages/Payment/Pay/_hooks/useBackgroundStyles";
import getBrandingSettings from "pages/Payment/Pay/_hooks/useGetBrandingSettings";

export const LoaderPaymentLink = () => {
  const { state } = useStateMachine();
  const link = state.link;
  const merchant = link?.merchant;

  const { brandColor, tinyBrandColor } = getBrandingSettings(merchant);
  const backgroundStyles = useBackgroundStyles(link, brandColor);

  const isBrandColorDark = brandColor && tinyBrandColor.isDark();
  const isBrandColorLight = brandColor && tinyBrandColor.isLight();

  const handleRenderLoaderColor = () => {
    if (isBrandColorDark) {
      return LoaderWhite;
    }

    if (isBrandColorLight) {
      return LoaderBlack;
    }

    return LoaderBlack;
  };

  return (
    <main
      className="flex min-h-100dvh items-center justify-center md:min-h-screen"
      style={backgroundStyles}
    >
      <Lottie
        options={{
          animationData: handleRenderLoaderColor(),
          loop: true,
        }}
        width={160}
        height={160}
      />
    </main>
  );
};

export default LoaderPaymentLink;
